export interface CreatedPurchaseOrderFromContracts {
  id: string;
  purchaseOrderNumber: number;
  contractNumber: number;
  supplierKey: string;
  supplierName: string;
  currencyCode: string;
  noOfLines: number;
  productKey: string;
  productDescription: string;
  productTypeDescription: string;
  quantity: number;
  unitOfMeasure: string;
  price: number;
  value: number;
  deliveryDate: Date;
}
